import { createFileRoute } from '@tanstack/react-router'
import { CoachScreen } from '@/features/coach/CoachScreen'

export const Route = createFileRoute('/coach')({
  component: CoachScreen,
})
